import { render, staticRenderFns } from "./Goal.vue?vue&type=template&id=3d2d849a&scoped=true"
import script from "./Goal.vue?vue&type=script&lang=js"
export * from "./Goal.vue?vue&type=script&lang=js"
import style0 from "./Goal.vue?vue&type=style&index=0&id=3d2d849a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2d849a",
  null
  
)

export default component.exports